'use client'

import Dropdown from '@lyra/core/components/Dropdown'
import Heading from '@lyra/core/components/Heading'
import Icon, { ChevronDown, ChevronUp } from '@lyra/core/components/Icon'
import Section, { SectionProps } from '@lyra/core/components/Section'
import MarketIcon from '@lyra/web/components/common/MarketIcon'
import { InstrumentType } from '@lyra/web/constants/instruments'
import { CurrencyId } from '@lyra/web/constants/tokens'
import useAllMarketStats from '@lyra/web/hooks/useAllMarketStats'
import { formatMarketSymbol } from '@lyra/web/utils/markets'
import React, { useState } from 'react'
import { XStack } from 'tamagui'

import MarketsDropdownSection from './MarketsDropdownSection'

type Props = {
  selectedCurrencyId: CurrencyId
  selectedInstrumentType: InstrumentType
} & SectionProps

const MarketsDropdown = ({ selectedCurrencyId, selectedInstrumentType, ...stackProps }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  // preload market data for dropdown
  useAllMarketStats()

  return (
    <Dropdown
      isPortaled
      onChangeOpen={setIsOpen}
      trigger={
        <Section
          {...stackProps}
          cursor="pointer"
          hoverStyle={{ backgroundColor: '$hoverBg' }}
          pressStyle={{ backgroundColor: '$pressBg' }}
          backgroundColor={isOpen ? '$hoverBg' : '$appBg'}
        >
          <Section.Header
            title={
              <XStack alignItems="center" gap="$1">
                <MarketIcon marketId={selectedCurrencyId} size={24} />
                <Heading size="h3">
                  {formatMarketSymbol(selectedCurrencyId, selectedInstrumentType)}
                </Heading>
              </XStack>
            }
            rightContent={
              <Icon
                icon={isOpen ? <ChevronUp strokeWidth={2} /> : <ChevronDown strokeWidth={2} />}
                size={24}
                color="secondary"
              />
            }
            height="100%"
            width="100%"
            alignItems="center"
          />
        </Section>
      }
      placement="bottom-start"
      $desktop={{
        height: 500,
        width: 700,
      }}
    >
      <MarketsDropdownSection />
    </Dropdown>
  )
}

export default MarketsDropdown
